var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"open":_vm.open}),_vm._v(" "),_c('modal',{attrs:{"show":_vm.show},on:{"closeModal":_vm.close}},[_c('assign-modal',{attrs:{"date":_vm.note.delivery_date},on:{"assign":_vm.assignToTeam}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }